<template>
    <PreLoginForm title="" :logo="false">
        <div class="nova-header mb-2">
            <img src="@/assets/img/novakid_logos.png" />
        </div>
        <div class="pre-login-title">{{ $t('SCHEDULE_TRIAL_LESSON') }}</div>
        <LoginTextInput
            :errors="errors"
            label="LABEL_KID_HISTORY_FIRSTNAME"
            placeholder="PLACEHOLDER_FIRST_NAME"
            autocomplete="given-name"
            name="name"
            v-model.trim="form.name"
        />
        <LoginSelectInput
            :errors="errors"
            :options="genderOptions"
            label="LABEL_GENDER"
            name="gender"
            v-model="form.gender"
        />
        <PreLoginDatepicker
            @input="handleInput('birth_date')"
            :errors="errors"
            label="REPORT_HEADER_BIRTHDATE"
            name="birth_date"
            v-model="form.birth_date"
        />
        <LoginSelectInput
            :errors="errors"
            :options="nativeTeacherOptions"
            label="TEACHER_CATEGORY"
            name="native_teacher"
            v-model="form.native_teacher"
        />
        <LoginSelectInput
            @input="handleInput('lesson_date')"
            :errors="errors"
            :loading="lessonDateLoading"
            :options="lessonDateOptions"
            :disabled="!form.birth_date"
            :modal="true"
            label="LESSON_DATE"
            placeholder="SELECT_DATE"
            name="lesson_date"
            v-model="form.lesson_date"
        />
        <LoginSelectInput
            :errors="errors"
            :loading="lessonHourLoading"
            :options="lessonHourOptions"
            :placeholder="lessonHourPlaceholder"
            :disabled="!form.lesson_date"
            :modal="true"
            label="LESSON_TIME"
            name="lesson_hour"
            v-model="form.lesson_hour"
            v-if="form.lesson_date"
        />
        <PreLoginButton
            @click="submit"
            :loading="loading"
            :label="$t('SCHEDULE_LESSON')"
            class="login-form-button"
        />
    </PreLoginForm>
</template>

<script>
import PreLoginForm from '@/views/PreLoginView/PreLoginForm'
import PreLoginButton from '@/views/PreLoginView/PreLoginButton'
import LoginSelectInput from '@/views/PreLoginView/LoginSelectInput.vue'
import LoginTextInput from '@/views/PreLoginView/LoginTextInput.vue'
import PreLoginDatepicker from '@/views/PreLoginView/PreLoginDatepicker.vue'
export default {
    components: {
        PreLoginForm,
        PreLoginButton,
        LoginSelectInput,
        LoginTextInput,
        PreLoginDatepicker
    },
    data() {
        return {
            form: {
                name: '',
                gender: 'male',
                birth_date: '2010-01-01',
                native_teacher: 'true',
                lesson_date: '',
                lesson_hour: ''
            },
            genderOptions: [
                { display: 'LABEL_MALE', key: 'male' },
                { display: 'LABEL_FEMALE', key: 'female' }
            ],
            nativeTeacherOptions: [
                { display: 'NATIVE_SPEAKER', key: 'true' },
                { display: 'PROFESSIONAL_LECTOR', key: 'false' }
            ],
            loading: false,
            lessonDateLoading: false,
            lessonHourLoading: false,
            errors: new this.$Errors(),
            daysToSelect: [],
            slots: []
        }
    },
    computed: {
        lessonHourPlaceholder() {
            return this.form.lesson_date ? 'CHOOSE_HOUR' : 'SELECT_DATE'
        },
        lessonDateOptions() {
            return this.daysToSelect.map(day => {
                return {
                    display: this.$moment(day).format('D MMMM, dddd'),
                    key: day
                }
            })
        },
        lessonHourOptions() {
            return this.slots.reduce((all, { start_time }) => {
                const display = this.$moment(start_time).format('HH:mm')
                return all.find(item => item.key == start_time)
                    ? [...all]
                    : [...all, { key: start_time, display }]
            }, [])
        }
    },
    methods: {
        handleInput(key) {
            switch (key) {
                case 'birth_date':
                    return this.onBirthDateSelect()
                case 'lesson_date':
                    return this.onLessonDateSelect()
            }
        },
        getFormValues() {
            const timestamp = +new Date()
            const { native_teacher, gender, birth_date } = this.form
            return `is_busy=false&accept_new_students=true&trial_rank_over_zero=true&region_code=PL&teacher_is_near_native=${native_teacher}&timestamp=${timestamp}&student_gender=${gender}&student_birth_date=${birth_date}`
        },
        async onLessonDateSelect() {
            try {
                this.lessonHourLoading = true
                const queries = this.getFormValues()
                const { lesson_date } = this.form
                const startTime = `${this.$moment(
                    lesson_date,
                    'YYYY-MM-DD'
                ).toISOString()}`
                const endTime = `${this.$moment(lesson_date, 'YYYY-MM-DD')
                    .add(1, 'days')
                    .toISOString()}`
                const url = `https://api.novakidschool.com/api/0/teachers_schedule/aggregated_slots?${queries}&order_by=start_time&start_time__gte=${startTime}&start_time__lte=${endTime}`

                this.slots = (await this.$api.get(url)).data._embedded.slots
            } catch (error) {
                this.$Notif.error('TOAST_DOWNLOADING_DATA_FAILED')
            } finally {
                this.lessonHourLoading = false
            }
        },
        onBirthDateSelect() {
            this.lessonDateLoading = true
            const queries = this.getFormValues()
            const startTime = `${this.$moment().toISOString()}`
            const endTime = `${this.$moment().add(1, 'months').toISOString()}`
            this.$novaApi
                .get(
                    `teachers_schedule/days?${queries}&start_time__gte=${startTime}&start_time__lte=${endTime}`
                )
                .then(({ data }) => {
                    this.daysToSelect = data.days
                })
                .catch(() => {
                    this.$Notif.error('TOAST_DOWNLOADING_DATA_FAILED')
                })
                .then(() => {
                    this.lessonDateLoading = false
                })
        },
        createFormData(payload) {
            return Object.entries(payload)
                .map(
                    ([key, value]) =>
                        `${encodeURIComponent(key)}=${encodeURIComponent(
                            value
                        )}`
                )
                .join('&')
        },
        resetHeaders() {
            this.$novaApi.defaults.headers = {
                'Content-Type': 'application/json'
            }
        },
        setFormDataHeaders() {
            this.$novaApi.defaults.headers = {
                'Content-Type':
                    'application/x-www-form-urlencoded;charset=UTF-8'
            }
        },
        setCandidate(data, id) {
            const payload = this.createFormData(data)
            return this.$novaApi
                .post(`trial_requests/${id}/user_candidates`, payload)
                .then(({ data }) => data)
        },
        getToken(data) {
            const payload = this.createFormData(data)
            return this.$novaApi
                .post(`auth/tokens`, payload)
                .then(({ data }) => {
                    this.$novaApi.defaults.headers['x-novakid-auth'] =
                        data.value
                    this.$query.setQuery({ user_id: data.user_id })
                    return data
                })
        },
        setStudent() {
            const { name, gender, birth_date } = this.form
            const { user_id } = this.$route.query
            const data = {
                name: name,
                gender: gender,
                birth_date: this.$moment(
                    birth_date,
                    'YYYY-MM-DD'
                ).toISOString(),
                birth_year: this.$moment(birth_date, 'YYYY-MM-DD').format(
                    'YYYY'
                )
            }
            const payload = this.createFormData(data)
            return this.$novaApi
                .post(`users/${user_id}/students`, payload)
                .then(({ data }) => {
                    this.$query.setQuery({ student: data.id })
                    return data
                })
        },
        setOperation() {
            const { native_teacher, lesson_hour } = this.form
            const { student, user_id } = this.$route.query
            const data = {
                action: 'safe_reserve',
                teacher_is_near_native: native_teacher,
                start_time: this.$moment(lesson_hour).toISOString()
            }
            const payload = this.createFormData(data)
            return this.$novaApi
                .post(
                    `users/${user_id}/students/${student}/schedule/operations`,
                    payload
                )
                .then(({ data }) => data)
        },
        async submit() {
            if (this.loading) {
                return
            }
            const { phone, email, id } = this.$route.query
            Object.entries(this.form).forEach(([key, val]) => {
                if (!val) {
                    this.errors.set(key)
                }
            })
            if (this.errors.errors.length > 0) {
                return
            }
            this.loading = true
            const token = 'vS6v@dAxN7'
            try {
                this.setFormDataHeaders()
                await this.setCandidate({ phone, email }, id)
                await this.getToken({ login: phone, password: token })
                await this.setStudent()
                await this.setOperation()
                this.resetHeaders()
                this.loading = false
                const { lesson_date, lesson_hour } = this.form
                this.$router.push({
                    params: { step: 'success' },
                    query: { lesson_date, lesson_hour }
                })
            } catch (error) {
                this.resetHeaders()
                if (error.response && error.response.data) {
                    this.$Notif.error(error.response.data.detail.msg, '')
                } else {
                    this.$Notif.error('TOAST_DOWNLOADING_DATA_FAILED')
                }
                this.loading = false
            }
        }
    },
    mounted() {
        const { gender, birthday, kid_name } = this.$route.query
        if (gender) {
            this.form.gender = gender == 'boy' ? 'male' : 'female'
        }
        if (birthday) {
            this.form.birth_date = birthday
        }
        if (kid_name) {
            this.form.name = kid_name
        }
        this.onBirthDateSelect()
    }
}
</script>
